import { I18n } from 'vue-i18n';
import { RouteRecordRaw } from 'vue-router';

export default (i18n: I18n): RouteRecordRaw => {
  return {
    path: '/whatsapp-flows',
    name: 'whatsapp-flows',
    component: () => import('@/modules/DefaultView.vue'),
    meta: {
      site: {
        t: i18n.global.t('whatsapp-flows.breadcrumb.list'),
      },
    },
    children: [
      {
        path: '',
        name: 'whatsapp-flows-list',
        component: () => import('@/modules/whatsapp-flows/views/WhatsappFlowsList.vue'),
      },
      {
        path: '/create-flow',
        name: 'whatsapp-flows-create',
        component: () => import('@/modules/whatsapp-flows/views/CreateFlow.vue'),
        meta: {
          site: {
            t: i18n.global.t('whatsapp-flows.breadcrumb.create'),
          },
        },
      },
    ],
  };
};
